import React from "react"
import Layout from "../components/Layout"
import { graphql, useStaticQuery } from "gatsby"
import SEO from '../components/SEO'
import Projects from "../components/Projects"

const query = graphql`
  {
    __typename
    allStrapiProjects {
      nodes {
        description
        github
        id
        title
        stack {
          id
          title
        }
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        url
      }
    }
  }
`

const ProjectsPage = () => {
  const {
    allStrapiProjects: { nodes: projects },
  } = useStaticQuery(query)

  console.log(projects)
  return (
    <Layout>
      <SEO  title="Projects" />
      <section className="project-page">
        <Projects
          projects={projects}
          title="Projects"
          isShowMoreEnabled={false}
        />
      </section>
    </Layout>
  )
}

export default ProjectsPage
